/** Version stamp — doc 18 §5 wants it on screen so bug reports can name it. */
export const VERSION = 'V0.7 · THE FAUNA GRADUATION';
